/**
 * Agrupa recargas disparadas por eventos de socket.
 *
 * O painel MomentsUser refazia GET /usersMoments a cada evento `appMessage` ou
 * `ticket` — ou seja, uma requisição por mensagem recebida na empresa, por
 * atendente com a tela aberta. Essa rota devolve todos os tickets abertos e
 * pendentes (1.727 na empresa 236, em produção), então a tela sozinha
 * respondia por boa parte do consumo do banco.
 *
 * Aqui os disparos viram no máximo uma requisição por janela, com no máximo
 * uma em voo: se chegarem eventos durante a busca, ela é refeita uma vez só ao
 * terminar, em vez de enfileirar uma por evento.
 *
 * @param {() => Promise<any>} buscar    o que executar (a requisição)
 * @param {number}             janelaMs  janela de agrupamento
 * @returns {{ disparar: () => void, agora: () => Promise<void>, cancelar: () => void }}
 */
export default function criarRecargaCoalescida(buscar, janelaMs = 3000) {
  let cancelado = false;
  let emVoo = false;
  let pendente = false;
  let timer = null;

  const executar = async () => {
    if (cancelado) return;
    if (emVoo) {
      pendente = true;
      return;
    }
    emVoo = true;
    try {
      await buscar();
    } finally {
      emVoo = false;
      if (pendente && !cancelado) {
        pendente = false;
        disparar();
      }
    }
  };

  function disparar() {
    if (cancelado || timer) return;
    timer = setTimeout(() => {
      timer = null;
      executar();
    }, janelaMs);
  }

  return {
    disparar,
    // Primeira carga da tela: sem esperar a janela.
    agora: executar,
    cancelar: () => {
      cancelado = true;
      if (timer) clearTimeout(timer);
      timer = null;
    }
  };
}
